import { plainToInstance, Type } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { ITaskTemplate } from './ITaskTemplate'
import { TaskTemplatePermittedActions, TaskTemplateStatus } from './types'
import { User } from '@core/entities/user'
import { TaskTemplateVersion } from '@core/entities/task/TaskTemplateVersion'
import {
  ITaskTemplateProperties,
  TaskTemplatePriorityType,
} from '@core/entities/task/TaskTemplateProperties'
import { ProcessTagsWrapper } from '@core/entities/processTags/ProcessTagsWrapper'
import { statuses } from '@core/theme/statuses'
export class TaskTemplate extends Entity<ITaskTemplate> {
  id: number

  name: string

  description: string

  status: TaskTemplateStatus

  @Type(() => TaskTemplateVersion)
  currentVersion?: TaskTemplateVersion

  permittedActions: TaskTemplatePermittedActions[]

  @Type(() => User)
  modifiedBy: User

  modifiedOn: string

  // NOTE: This is not implemented by the API yet.
  code?: string

  @Type(() => ProcessTagsWrapper)
  processTags?: ProcessTagsWrapper

  /**
   * NOTE: This is only used for linked processes and paginated tasks
   */
  templateVersionId?: number
  version?: number
  // END OF NOTE

  public static new(payload: unknown): TaskTemplate {
    const entity = plainToInstance(TaskTemplate, payload)

    return entity
  }

  public getStatusChipColor() {
    switch (this.status) {
      case 'DRAFT':
        return statuses.draft.color
      case 'ARCHIVED':
        return statuses.archived.color
      default:
        return statuses.active.color
    }
  }

  public static statusString(status: TaskTemplateStatus): string {
    switch (status) {
      case 'DRAFT':
        return statuses.draft.label
      case 'ARCHIVED':
        return statuses.archived.label
      case 'LIVE':
        return statuses.active.label
      default:
        return status
    }
  }

  public getStatusString(): string {
    return TaskTemplate.statusString(this.status)
  }

  public getNextStepId(): string {
    // We get the next step id if it exists, otherwise we get the creation step id
    return (
      this.currentVersion?.steps?.taskSteps?.[1]?.id ||
      this.currentVersion?.steps?.taskSteps?.[0]?.id
    )
  }

  public getDueDateConfig(): ITaskTemplateProperties['dueDateConfig'] {
    return this.currentVersion?.properties?.dueDateConfig
  }

  public getAttachmentRequired(): boolean {
    return !this.currentVersion?.properties?.attachmentsConfig?.optional
  }

  public getDueDateRequired(): boolean {
    return !this.currentVersion?.properties?.dueDateConfig?.optional
  }

  public getDueDatePrioritySetsTheDueDate(): boolean {
    return this.currentVersion?.properties?.dueDateConfig
      ?.prioritySetsTheDueDate
  }

  public getPriorityOptions(): TaskTemplatePriorityType[] {
    return this.currentVersion?.properties?.dueDateConfig?.prioritySetsTheDueDateConfig?.defaultPriorityValues.map(
      (value) => value.priority,
    )
  }

  public getPriorityDefaultValue(): TaskTemplatePriorityType {
    return this.currentVersion?.properties?.priorityConfig?.defaultValue
  }
}
